import {Component, EventEmitter, Input, Output, effect, signal, inject} from '@angular/core';
import {NgbModal, NgbModalConfig, NgbPopoverModule} from "@ng-bootstrap/ng-bootstrap";
import {CompromiseReports} from "../../../service/global.service";
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { HasRolesDirective } from 'keycloak-angular';
import { ModalpartComponent } from 'src/app/components/modalpart/modalpart.component';
import { CommonModule } from '@angular/common';
import Keycloak from 'keycloak-js';


@Component({
    selector: 'app-compromise-report-modal',
    templateUrl: './compromise-report-modal.component.html',
    styleUrls: ['./compromise-report-modal.component.scss'],
    providers: [NgbModalConfig, NgbModal, TranslationService],
    imports: [ 
      CommonModule,
      TranslateModule,
      NgbPopoverModule,
      ModalpartComponent,
      HasRolesDirective
    ],
    standalone: true
})
export class CompromiseReportModalComponent {
  @Input() comproCourante?: CompromiseReports;
  @Input() listeprobes?: string[];
  @Output() filtreApp = new EventEmitter<string>();

  readonly translationService = inject(TranslationService);
  readonly keycloak = inject(Keycloak);
  title = signal('');

  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
    effect(() => {
      this.translationService.get('menu-compromise-reports').subscribe(menu => {
        this.translationService.get('compromise-reports-title-details').subscribe(details => {
          this.title.set(`DIP - ${menu} - ${details} ${this.comproCourante?.id ?? ''}`);
        });
      });
    });
  }

  open({ content }: { content: any }) {
    this.modalService.open(content, { size: 'xl' });
    document.title = this.title();
  }

  getAllDetectors(family: string) {
    let listeDetec: any[] = [];
    if (this.comproCourante?.detectors) {
      const familyLower = family.toLowerCase();
      this.comproCourante.detectors.forEach(detector => {
        const detectorFamily = detector.family?.toLowerCase();
        if (detectorFamily === familyLower || (familyLower === 'jailbreak' && detectorFamily === 'root')) {
          listeDetec.push(detector);
        }
      });
    }
    return listeDetec;
  }

  statutProbe(family: string) {
    let statut = "probe-ok";
    if (this.comproCourante?.detectors) {
      const familyLower = family.toLowerCase();
      this.comproCourante.detectors.forEach(detector => {
        const detectorFamily = detector.family?.toLowerCase();
        if (detectorFamily === familyLower || (familyLower === 'jailbreak' && detectorFamily === 'root')) {
          statut = "probe-fatal";
        }
      });
    }
    return statut;
  }

  decitohexa(id: number | undefined) {
    if (id) {
      if (id < 0) {
        id = 0xFFFFFFFF + id + 1;
      }
      return id.toString(16).toUpperCase();
    } else return "Unknown ID";
  }

  formatDetectorName(name: string | undefined) {
    if (name) {
      name = name.replaceAll("_", " ");
      return name;
    } else return "Unknown detector";
  }

  getApp(event: string) {
    this.filtreApp.emit(event);
  }

  resetTitle() {
    this.translationService.get('menu-compromise-reports').subscribe(menu => {
      this.translationService.get('list').subscribe(list => {
        document.title = `DIP - ${menu} - ${list}`;
      });
    });
  }

  hasRequiredRole(){
    return this.keycloak.hasRealmRole('bo-dip-technical-detectors-viewer');
  }
}
